import { authApi } from "../auth/authApi";
import { API_GATEWAY_VERSION, apiGatewayClient } from "../clients";
import { User } from "./userTypes";

export const userApi = {
  fetchLoggedInUser: async () => {
    const token = await authApi.getCognitoUser();
    const userId = token["custom:user_id"];
    if (!userId) throw new Error("No user id found in token for current user");
    return userApi.fetchUser(userId);
  },
  fetchUser: async (userId: string) => {
    const { data } = await apiGatewayClient.request<User>({
      url: `/user/${API_GATEWAY_VERSION}/users/${userId}`,
    });

    return data;
  },
};
